// extracted by mini-css-extract-plugin
export var bannerArea = "sidebar-module--bannerArea--0a7a0";
export var latestArticles = "sidebar-module--latestArticles--cf58a";